__turbopack_context__.v({
  "caption": "Hero-module__rJelUa__caption",
  "marquee": "Hero-module__rJelUa__marquee",
  "marqueeInner": "Hero-module__rJelUa__marqueeInner",
  "marqueeItem": "Hero-module__rJelUa__marqueeItem",
  "root": "Hero-module__rJelUa__root",
});
